module.exports = __webpack_public_path__ + "static/media/fast-food-gastronomy-2-svgrepo-com.33c19674.svg";